import StickerApi from '@/api/sticker'
import SurveyApi from '@/api/survey'
import WpWebhookApi from '@/api/wpWebhook'
import GlobalConfigurationApi from '@/api/global-configuration'
import TemplateCollectionApi from '@/api/template-collection'
import ScimApi from '@/api/scim'
import PresentationsApi from '@/api/presentations'
import AccountsApi from '@/api/accounts'
import MarketplaceLicenseApi from '@/api/marketplace-license'
import BackdoorApi from '@/api/backdoor'
import ServiceTokensApi from '@/api/service-tokens'
import AccountRemovalApi from '@/api/account-removal'
import TemplatePacksApi from '@/api/template-packs'

const initResources = () => {
  StickerApi.initResource()
  SurveyApi.initResource()
  WpWebhookApi.initResource()
  GlobalConfigurationApi.initResource()
  TemplateCollectionApi.initResource()
  ScimApi.initResource()
  PresentationsApi.initResource()
  AccountsApi.initResource()
  MarketplaceLicenseApi.initResource()
  BackdoorApi.initResource()
  ServiceTokensApi.initResource()
  AccountRemovalApi.initResource()
  TemplatePacksApi.initResource()
}

export default {
  initResources,
}
